import { make } from "vuex-pathify";

interface GuestInfo {
  email: string;
  token: string;
  transactionType: string;
}
interface State {
  guestInfo: GuestInfo;
}

const defaultState = () => {
  return {
    guestInfo: {
      email: "",
      token: "",
      transactionType: ""
    }
  };
};

const state = defaultState();

const mutations = {
  ...make.mutations(state),
  SET_GUEST_INFO_STATE(state: State, guestInfo: GuestInfo) {
    state.guestInfo = guestInfo;
  }
};

const actions = {
  ...make.actions(state),
  setGuestInfo({ commit }: { commit: Function }, guestInfo: GuestInfo) {
    commit("SET_GUEST_INFO_STATE", guestInfo);
  },
  setDefaultState({ commit }: { commit: Function }) {
    commit(
      "SET_GUEST_INFO",
      Object.assign({}, state, defaultState().guestInfo)
    );
  }
};

const getters = {
  ...make.getters(state),
  getGuestInfo() {
    return state.guestInfo;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
